import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiGoogle';
export const ENDPOINT_API_PATH = 'endpoint';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH); // cria nome da entidade de resposta dinamicamente. É usado no retorno do servico para identificar de qual API o erro corresponde
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS'; // tipo de Autorization usada pela API
const URL_POSTMAN = 'https://smiles-sa.postman.co/workspace';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  // Aqui vão os outros retornos de erro da API
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
